import axios from 'axios';

const state = {
	profiles: [],
};

const getters = {
	getProfiles: state => {
		return state.profiles;
	},
};

const actions = {
	// Lista paginata dei profili (solo SuperAdmin), sezione Gestione > Profili.
	// Ricerca, filtri, ordinamento e paginazione sono lato server: settings = { search, filters, options }
	asyncFetchProfiles: (context, settings) => {
		let url = 'profile/all';
		const config = settings || {};
		const filters = config.filters || {};
		const options = config.options || {};
		const params = {
			search: config.search || '',
			page: options.page || 1,
			itemsPerPage: options.itemsPerPage || 25,
			sortBy: (options.sortBy && options.sortBy[0]) || 'created_at',
			sortDesc: !!(options.sortDesc && options.sortDesc[0]),
		};
		if (filters.billingType) params.billingType = filters.billingType;
		if (filters.financeStatus) params.financeStatus = filters.financeStatus;
		if (typeof filters.active === 'boolean') params.active = filters.active;

		return axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				params: params,
			})
			.then(res => {
				context.commit('setProfiles', res.data.data);
				return res.data.pagination;
			})
			.catch(err => {
				if (err.response && err.response.status === 401) {
					context.commit('profile/setLogout', {}, { root: true });
				}
				throw err;
			});
	},
	// Aggiornamento rapido dello stato attivo/non attivo (PATCH)
	patchActive: (context, payload) => {
		let url = 'profile/active';
		return new Promise((resolve, reject) => {
			axios
				.patch(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })
				.then(res => {
					context.commit('setActive', { _id: payload._id, active: payload.active });
					resolve(res.data);
				})
				.catch(err => {
					if (err.response && err.response.status === 401) {
						context.commit('profile/setLogout', {}, { root: true });
					}
					reject(err);
				});
		});
	},
	// Eliminazione definitiva del profilo e di tutti i dati collegati.
	// payload: { _id, confirmName } - confirmName e' il nome digitato dall'utente.
	deleteProfile: (context, payload) => {
		let url = 'profile/remove';
		return new Promise((resolve, reject) => {
			axios
				.delete(`${context.rootGetters['settings/getUrl']}${url}`, {
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					data: payload,
				})
				.then(res => {
					context.commit('removeProfile', payload._id);
					resolve(res.data);
				})
				.catch(err => {
					if (err.response && err.response.status === 401) {
						context.commit('profile/setLogout', {}, { root: true });
					}
					reject(err);
				});
		});
	},
	// Un profilo per la pagina Modifica profilo (solo SuperAdmin)
	fetchProfile: (context, id) => {
		return axios
			.get(`${context.rootGetters['settings/getUrl']}profile/manage/${id}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			})
			.then(res => res.data.data)
			.catch(err => {
				if (err.response && err.response.status === 401) {
					context.commit('profile/setLogout', {}, { root: true });
				}
				throw err;
			});
	},
	// Nuovo profilo (solo SuperAdmin): anagrafica, spedizione, fatturazione, contratto e affiliato insieme
	createProfile: (context, payload) => {
		return axios
			.post(`${context.rootGetters['settings/getUrl']}profile/create`, payload, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			})
			.then(res => res.data)
			.catch(err => {
				if (err.response && err.response.status === 401) {
					context.commit('profile/setLogout', {}, { root: true });
				}
				throw err;
			});
	},
	// Aggiorna i dati anagrafici di un profilo
	updateProfile: (context, payload) => {
		let url = 'profile/anagrafica';
		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })
				.then(res => {
					// il refetch lo fa la view, che conosce ricerca/filtri/pagina correnti
					resolve(res.data);
				})
				.catch(err => {
					if (err.response && err.response.status === 401) {
						context.commit('profile/setLogout', {}, { root: true });
					}
					reject(err);
				});
		});
	},
	// Aggiorna i dati contrattuali del profilo (solo SuperAdmin). payload: { _id, finance }
	updateFinance: (context, payload) => {
		let url = 'profile/finance';
		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					if (err.response && err.response.status === 401) {
						context.commit('profile/setLogout', {}, { root: true });
					}
					reject(err);
				});
		});
	},
};

const mutations = {
	setProfiles: (state, value) => {
		state.profiles = value;
	},
	removeProfile: (state, _id) => {
		state.profiles = state.profiles.filter(p => p._id !== _id);
	},
	setActive: (state, { _id, active }) => {
		const profile = state.profiles.find(p => p._id === _id);
		if (profile) {
			profile.active = active;
		}
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
